import React from 'react';
import { Select, InputNumber, Input, Button } from 'antd';
import style from './index.scss';

// const getConditionOptions = (riskIndicatorsState, recordData) => {
//   const rule = riskIndicatorsState.find(
//     (indicator) => indicator.displayName === recordData.name
//   );
//   console.log({ rule });
//   if (rule && Array.isArray(rule.supportedConditions))
//     return rule.supportedConditions.map((cond) => (
//       <Select.Option value={cond} key={cond}>
//         {cond}
//       </Select.Option>
//     ));
//   return [];
// };

export const getTableColumns = (
  Loading,
  tableData,
  riskIndicatorsState,
  handleDeleteRuleConfirm,
  handleWeightUpdate,
  disabled
) =>
  Loading
    ? []
    : [
        {
          title: 'Risk Indicator',
          dataIndex: 'displayName'
        },
        // {
        //     title: 'Condition',
        //     align: 'center',
        //     render: (text, record, index) => (
        //         <Select
        //             className={style.conditionSelect}
        //             size="small"
        //             value={record.selectedCondition}
        //             onChange={(value) => handleConditionChange(index, value)}>
        //             {getConditionOptions(riskIndicatorsState, record)}
        //         </Select>
        //     )
        // },
        // {
        //     title: 'Value',
        //     align: 'center',
        //     render: (text, record, index) => (
        //         <Input
        //             className={style.valueInput}
        //             size="small"
        //             // type={inputType}
        //             value={record.value}
        //         >
        //         </Input>
        //     )
        // },
        {
          title: 'Weight',
          align: 'center',
          render: (text, record, index) => (
            <InputNumber
              className={style.valueInput}
              size="small"
              min={0}
              max={100}
              value={record?.weight}
              onChange={(value) => {
                if (isNaN(value) || value < 0) {
                  return;
                }
                handleWeightUpdate(value, record);
              }}
              disabled={disabled}
            />
          )
        },
        {
          title: 'Action',
          align: 'center',
          render: (text, record, index) => (
            <Button
              type="text"
              size="small"
              icon={<i className={style.trashIcon} />}
              title="Delete"
              onClick={(e) => handleDeleteRuleConfirm(record, e)}
              disabled={disabled}
            />
          )
        }
      ];
